export default __webpack_public_path__ + "static/media/Jobboards.db978994.svg";